import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import { appTheme } from '../../../../helpers/utils/Utils';


const UpdateNotificationSuccessModal = ({ isSubErrMsg, ModalClose, errormsg }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleHome = () => {
        ModalClose(false)
        navigate('/home')
    }

    const handleClose = () => {
        ModalClose(false)
    }

    return (
        <div className=' flex flex-col justify-center items-center w-full'>
            <div className=' flex flex-col gap-4 justify-center items-center w-full'>
                <button autoFocus class="focus:outline-none font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={handleHome}>{t("Home")}</button>
                <button className={`${kudzuPlusTrue ? 'text-white' : 'text-[#2965FB]'} focus:outline-none font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-[#2965FB] cursor-pointer px-2 py-4 border-[3px] border-solid border-[#2965FB] bg-transparent w-full`} onClick={handleClose}> {t('Cancel')} </button>
            </div>
        </div>
    )
}

export default withOidcSecure(UpdateNotificationSuccessModal)